import React from "react";
import DashboardClasses from "../../../Pages/dashboard.module.css";

function Vendordoc({ doc, updateVendorDocs, setData, deleteDocData, info }) {
    return (
        <div className={DashboardClasses["vendorDoc-wrapper"]}>
            {doc.length > 0 && (
                <div className={DashboardClasses["vendorDocs"]}>
                    {doc.map((document) => (
                        <div className={DashboardClasses["doc"]}>
                            <h3>{document.doc}</h3>
                            <h5>:</h5>
                            <div
                                className={
                                    DashboardClasses["document-details"]
                                }>
                                <div
                                    className={
                                        DashboardClasses["vendordoclink"]
                                    }>
                                    <a
                                        href={`${document.documentURL}`}
                                        target="_blank"
                                        rel="noreferrer">
                                        <img
                                            src={`${document.documentURL}`}
                                            alt=""
                                        />
                                        <br />
                                    </a>
                                    <p>
                                        {document.doc == "Aadhar" &&
                                            document.aadhar}
                                        {document.doc == "Pan" && document.pan}
                                        {document.doc == "Bank book" &&
                                            document.accountnumber}
                                        {document.doc == "Vehicle RC" &&
                                            document.vehiclercnumber}
                                        {document.doc == "Driving Licence" &&
                                            document.dlnumber}
                                    </p>
                                </div>
                                <div
                                    className={
                                        DashboardClasses["control-btns"]
                                    }>
                                    {(document?.status != "Approved" ||
                                        !document?.status) && (
                                        <button
                                            className={
                                                DashboardClasses["doc-approve"]
                                            }
                                            disabled={info.status == "Active"}
                                            onClick={() => {
                                                updateVendorDocs(
                                                    document._id,
                                                    setData
                                                );
                                            }}>
                                            Approve
                                        </button>
                                    )}
                                    <button
                                        className={
                                            DashboardClasses["doc-delete"]
                                        }
                                        onClick={() => {
                                            deleteDocData(
                                                document._id,
                                                document.doc
                                            );
                                        }}>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Vendordoc;
